<template>
  <div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
      <span v-if="params.column.colDef.filter" ref="menuButton" class="ag-header-icon ag-filter-icon"
            :class="{active: filterActive}"
            @click="onMenuClicked"></span>
      <span ref="eText" class="ag-header-cell-text" role="columnheader">
        {{ params.displayName }}
      </span>
      <span class="ag-info-icon" v-if="params.infoIcon" @click="openInfoPopup"></span>
      <template>
          <span v-if="!sortType && params.column.colDef.sortable" ref="eSortOrder"
                class="ag-header-icon icon-sorting ag-sort-order"
                @click="onSortRequested('asc', $event)"></span>
        <span ref="eSortAsc" v-else-if="sortType === 'asc'" class="ag-header-icon ag-sort-ascending-icon icon-sorting"
              @click="onSortRequested('desc', $event)"></span>
        <span ref="eSortDesc" v-else-if="sortType === 'desc'"
              class="ag-header-icon ag-sort-descending-icon icon-sorting"
              @click="onSortRequested('', $event)"></span>
        <sort-tooltip-renderer :isAscSort="isAscSort"/>
      </template>
    </div>
  </div>
</template>

<script>
import SortTooltipRenderer from '@/components/sort-tooltip-renderer'

export default {
  // This component used to permission header in staff-list-table
  // It's used to style a specific column-header in ag-grid
  name: 'column-header-renderer',
  components: { SortTooltipRenderer },
  data () {
    return {
      sortType: null,
      filterActive: false
    }
  },

  mounted () {
    if (this.params) {
      this.params.column.addEventListener('filterChanged', this.onFilterChanged)
    }
  },

  computed: {
    isAscSort () {
      return this.sortType === 'asc'
    }
  },

  methods: {
    openInfoPopup () {
      this.$parent.$parent.togglePermissionsInfo()
    },
    onMenuClicked () {
      this.params.showColumnMenu(this.$refs.menuButton)
    },
    onFilterChanged () {
      this.filterActive = this.params.column.filterActive
    },

    onSortRequested (order, event) {
      this.params.setSort(order, event.shiftKey)
      this.sortType = this.params.column.sort
    }
  }
}
</script>

<style lang="scss" scoped>
.ag-cell-label-container {
  position: relative;
  overflow: visible;
  z-index: 1000;
}

.ag-header-cell-label {
  &:hover {
    .ag-sort-order,
    .ag-filter-icon {
      display: block;
    }
  }
}

.ag-sort-order {
  position: relative;
  background-image: url("../assets/images/team-panel/sort.svg");
  background-repeat: no-repeat;
  background-size: auto;
  width: 19px;
  height: 15px;
  margin-inline-start: 7px;
  margin-top: 5px;

  &.active {
    background-image: url("../assets/images/team-panel/sort_active.svg");
  }
}

.ag-sort-order {
  display: none;
}

.ag-filter-icon {
  background-image: url("../assets/images/team-panel/filter.svg");
  background-repeat: no-repeat;
  width: 20px;
  height: 10px;
  float: left;
  margin: 0 0 0 3px;

  &.active {
    background-image: url("../assets/images/team-panel/filter_active.svg");
  }
}

.ag-sort-descending-icon {
  background-image: url("../assets/images/team-panel/sort_active.svg");
  width: 19px;
  height: 13px;
  background-repeat: no-repeat;
  margin-inline-start: 7px;
  margin-top: 5px;
}

.ag-sort-ascending-icon {
  background-image: url("../assets/images/team-panel/sort_active.svg");
  width: 19px;
  height: 13px;
  background-repeat: no-repeat;
  transform: rotate(180deg);
  margin-inline-start: 7px;
}
</style>
